import {
    either, isEmpty, isNil,
} from 'ramda'

// isNilOrEmpty :: a -> Boolean
export const isNilOrEmpty = either(isNil, isEmpty)
